<template>
    <div>
        <video :id="tcPlayerId" class="tencent-player" preload="auto" :controlBar="{playbackRateMenuButton:false,}" playsinline webkit-playsinline  ></video>
    </div>
</template>
<script>

export default {
    name: 'TencentPlayer',
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mounted() {
        this.loadJS();
       
    },
    data() {
        return {
            tcPlayerId : 'tcPlayer' + Date.now(),
            player: null,
            videoHigh:"200px",
            timer:null
        };
    },
    watch: {
        options: {
            handler(newV, oldV) {
                this.$nextTick(() => {
                    console.log("newV ==",newV)
                    this.player&&this.player.dispose();
                    
                });
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        //设置cookie
        setCookie(videoId, currentTime, exdays) {
            var exdate = new Date(); //获取时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
            //字符串拼接cookie
            window.document.cookie =
                "video_"+videoId + "=" + currentTime + ";path=/;expires=" + exdate.toGMTString();
        },
        //读取cookie
        getCookie: function(videoId) {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split("="); //再次切割
                    //判断查找相对应的值
                    if (arr2[0] == "video_"+videoId) {
                        return arr2[1]; //保存到保存数据的地方
                    } 
                }
            }
        },
         loadTcScript(cb) {
            this.loadScript(cb, {
                id: 'tcPlayerScriptId',
                url: '/static/tcplayer.v4.2.1.min.js',
            });
        },
         loadScript(cb, obj) {
            if (document.getElementById(obj.id)) {
                cb();
            } else {
                const script = document.createElement('script');
                script.async = true;
                script.src = obj.url;
                script.id = obj.id;
                script.onload = () => {
                    cb();
                };
                document.body.appendChild(script);
            }
        },
        loadJS() {
            console.log("loadJS")
            if (window.TCPlayer) {
                this.initVideo();
            } else {
                this.loadTcScript(() => {
                    this.initVideo();
                });
            }
        },
        initVideo() {
            setTimeout(() => {
                if (!this.player) {
                    this.player = TCPlayer(this.tcPlayerId, {controlBar:{playbackRateMenuButton:false,progressControl:false}});
                    this.player.src(this.options.url);
                    if(this.options.videoId) {
                        let time = this.getCookie(this.options.videoId)
                        if(time)this.player.currentTime(time)
                    }
                    this.timer = setInterval(()=>{
                        this.setCookie(this.options.videoId,this.player.currentTime(),365)
                    },5000)
                } else {
                    this.player.src(this.options.url);
                    if(this.options.videoId) {
                        if(this.getCookie(this.options.videoId))
                            this.player.currentTime(this.options.currentTime)
                    }
                    this.timer = setInterval(()=>{
                        this.setCookie(this.options.videoId,this.player.currentTime())
                    },5000)
                }
            },200);
        }
    },
    beforeDestroy() {
        this.player.dispose()
        if(this.timer)
        {
            clearInterval(this.timer)
        }
    }
};
</script>
<style  scoped>
/* @import url("../../assets/tcplayer.min.css"); */
.tencent-player{
    width: 100%;
    height: 100%;
}
</style>